import React from "react";
import { Timeline } from "primereact/timeline";
import StepCard from "./StepCard";

const SidebarContent = ({
  data,
  labels,
  nameLink,
  endType,
  overrideName = "",
  isEntityAccessAudit = false,
  objectType = "",
}) => {
  const filteredData = data?.filter(
    (item) => item !== null && item !== undefined,
  );

  const events = filteredData.length
    ? filteredData.map((item) => {
        return {
          content: (
            <StepCard
              data={item}
              labels={labels}
              nameLink={nameLink}
              endType={endType}
              overrideName={overrideName}
              isEntityAccessAudit={isEntityAccessAudit}
              objectType={objectType}
            />
          ),
        };
      })
    : [1, 2, 3].map((item) => {
        return {
          content: (
            <StepCard
              data={null}
              labels={labels}
              nameLink={nameLink}
              endType={endType}
              overrideName={overrideName}
              isEntityAccessAudit={isEntityAccessAudit}
              objectType={objectType}
            />
          ),
        };
      });

  return (
    <div className="sidebar-content-container">
      <Timeline value={events} content={(item) => item.content} />
    </div>
  );
};

export default SidebarContent;
